
import Vue from 'vue';
import { Button, Icon } from '@descomplica/vue-components';

export default Vue.extend({
  components: { Button, Icon },
  computed: {
    currentCourseName(): string {
      return this.$store.getters.currentCourse?.name || '';
    },
  },
  methods: {
    openStudyPlanningConfigModal(): void {
      this.$emit('openCreateStudyPlanningModal');
    },
  },
});
